import React, { useEffect, useState } from "react";
import style from "css/device.module.css";

function Shoppingmall(props) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={style.device_shopping_mall_wrap}>
      <div className={style.device_shopping_mall_top}>
        <img
          src={
            props.type === "bar"
              ? `${process.env.REACT_APP_CLIENT_URL}img/device/neat/shopping_mall_top${isMobile ? "_m" : ""}.webp`
              : `${process.env.REACT_APP_CLIENT_URL}img/device/neat/shopping_mall_top_frame${isMobile ? "_m" : ""}.webp`
          }
          alt="shopping_mall_top"
        />
      </div>
      <div className={style.device_shopping_mall_info_wrap}>
        <img
          src={
            `${process.env.REACT_APP_CLIENT_URL}img/device/neat/shopping_mall_logo${isMobile ? "_m" : ""}.png`
          }
          alt="shopping_mall_logo"
        />
        <div className={style.device_shopping_mall_search_wrap}>
          <img
            src={
              props.type === "bar"
                ? `${process.env.REACT_APP_CLIENT_URL}img/device/neat/shopping_mall_search${isMobile ? "_m" : ""}.png`
                : `${process.env.REACT_APP_CLIENT_URL}img/device/neat/shopping_mall_search_frame${isMobile ? "_m" : ""}.png`
            }
            alt="shopping_mall_search"
          />
        </div>
        <div className={style.device_shopping_mall_info_text_wrap}>
          <div className={style.device_shopping_mall_info_label}>
            <span>
              <img
                src={
                  props.type === "bar"
                    ? `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/device/neat/title_neat_bar.webp"
                    : `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/device/neat/title_neat_frame.webp"
                }
                alt="bar"
              />
            </span>
            는{isMobile ? <br /> : " "}<span>나라장터 종합쇼핑몰에{isMobile ? <br /> : " "}등록되어 있는 제품</span>입니다.
          </div>
          <div className={style.device_shopping_mall_info_text}>
            스마트한 회의 환경 구축을 위한 {isMobile ? (<><br /></>) : " "}
            {props.type === "bar" ? "Neat Bar를" : "Neat Frame을"} 지금
            만나보세요.
          </div>
        </div>
      </div>
      <div className={style.device_shopping_mall_botom}>
        <img
          src={
            `${process.env.REACT_APP_CLIENT_URL}img/device/neat/shopping_mall_bottom${isMobile ? "_m" : ""}.webp`
          }
          alt="shopping_mall_bottom"
        />
        <div className={style.device_shopping_mall_botom_text}>
          <span>“리브테크놀로지”</span> 또는{isMobile ? <><br /></> : " "}
          <span>“영상회의시스템”</span>을
          검색하면
          <br />{isMobile && <><br /></>}
          Neat Bar와 Neat Frame을 만날 수 있습니다.
        </div>
      </div>
    </div>
  );
}

export default Shoppingmall;
